import * as React from 'react';
import { Box } from '@mui/material';
import { FlexBoxInline } from '../../@shared/templates';
import TabsContentMonitoringDataSize, { TabsContentMonitoringModelUsageProps } from './TabsContentMonitoringDataSize';
import TabsContentMonitoringDataItemsCount from './TabsContentMonitoringDataItemsCount';
import TabsContentMonitoringModelsUsage from './TabsContentMonitoringModelsUsage';
import TabsContentMonitoringSchemaCpuUsage from './TabsContentMonitoringSchemaCpuUsage';


type TabsContentMonitoringProps = TabsContentMonitoringModelUsageProps & {
  isVisible: boolean
}

const TabsContentMonitoring = (props: TabsContentMonitoringProps) => {
  return <div hidden={!props.isVisible}>
    <Box sx={{ ...FlexBoxInline, gap: "20px", marginBottom: "20px" }}>
      <Box sx={{ width: "100%" }}>
        <TabsContentMonitoringModelsUsage schemaId={props.schemaId} />
      </Box>
    </Box>
    <Box sx={{ ...FlexBoxInline, gap: "20px", marginBottom: "20px" }}>
      <Box sx={{ width: "50%" }}>
        <TabsContentMonitoringDataSize schemaId={props.schemaId} />
      </Box>
      <Box sx={{ width: "50%" }}>
        <TabsContentMonitoringDataItemsCount schemaId={props.schemaId} />
      </Box>
    </Box>
    <Box sx={{ ...FlexBoxInline, gap: "20px" }}>
      <Box sx={{ width: "100%" }}>
        <TabsContentMonitoringSchemaCpuUsage schemaId={props.schemaId} />
      </Box>
    </Box>
  </div>
}

export default TabsContentMonitoring;
